<template>
  <div>
    <v-dialog v-if="pDataPass.isVisibleLoad" v-model="dLoadingCharge" hide-overlay persistent width="300">
      <v-card class="datModalTitleContainer" dark>
        <v-card-text>
          {{ $t('cargandoContenido') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs3>
        <v-text-field color="datPrimary" id="codUserDat" ref="codUserDat" clearable class="pr-1" name="code"
          :disabled="dDisabledInput" :label="$t(pDataPass.textCodigo)" v-model="dSelected.codigo"
          @click:append="fAbreBuscador" @click:clear="fClear()" @change.native="fSeleccionaElemento">
        </v-text-field>
      </v-flex>
      <v-flex xs9>
        <v-text-field color="datPrimary" id="nameUserDat" ref="nameUserDat" clearable class="pl-1"
          :error-messages="dErrorMessagesComponente" :name="$t(pDataPass.label)" :disabled="dDisabledInput"
          :required="pDataPass.required" :label="$t(pDataPass.label)" v-model="dSelected.nombre"
          append-icon="mdi-text-search" @click:append="fAbreBuscador" @change.native="fSeleccionaElemento">
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dDataTable.isVisible" max-width="500px">

      <v-toolbar dark class="primaryColorBackground">
        <v-toolbar-title>{{ $t(pDataPass.title) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fCloseDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <data-new-table ref="TablaInterna" :pData="dDataTable" @recharge="fCargaEvent" @selectItem="fSelectItem">
      </data-new-table>
    </v-dialog>
  </div>
</template>

<script>
import SrvGeneral from '@/services/srv-general'

import DataNewTable from '@/components_datadec/DataNewTable'

export default {
  components: {
    DataNewTable
  },
  props: {
    pDataPass: {
      type: Object,
      required: true,
      default: {
        'errorMessages': [],
        'label': '',
        'rowsPerPage': 5,
        'headers': [],
        'urlWS': '',
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': '', 'nombre': '' },
        'resultName': '',
        'request': {},
        'default': {},
        'disabled': false,
        'required': false,
        'orderByDefault': '1',
        'orderDefault': 'ASC',
        'isVisibleLoad': false,
        'textCodigo': '',
        'title': '',
        'cliente': ''
      }
    }
  },
  data() {
    return {
      dErrorMessagesComponente: this.pDataPass.errorMessages,
      dDisabledInput: this.pDataPass.disabled,
      dSelected: { codigo: '', nombre: '', clientRef: '' },
      dActivaBusqueda: false,
      dLoadingCharge: false,
      dDataTable: {
        'headers': this.pDataPass.headers,
        'items': [],
        'initSearch': '',
        'totalItems': 0,
        'checkboxOn': false,
        'rowsPerPage': this.pDataPass.rowsPerPage,
        'loading': false,
        'isVisible': false,
        'descending': this.pDataPass.orderDefault !== 'ASC',
        'sortBy': this.pDataPass.orderByDefault,
        'page': 1
      }
    }
  },
  watch: {
    default: {
      deep: true,
      handler() {
        if (this.pDataPass.item.codigo) {
          this.dSelected = this.pDataPass.item ? {
            codigo: this.pDataPass.item.codigo,
            nombre: this.pDataPass.item.nombre
          } : {}
        }
      }
    },
    disabled: {
      handler() {
        this.dDisabledInput = this.pDataPass.disabled
      }
    },
    errorMessages: {
      handler() {
        this.dErrorMessagesComponente = this.pDataPass.errorMessages
      }
    },
    /**
     * Comprueba si el valor es numerico
     */
    'dSelected.codigo': function (val, oldVal) {
      if ((this.dSelected.codigo === '') || (this.dSelected.codigo === undefined)) {
        this.dSelected.nombre = ''
        this.dErrorMessagesComponente = []
        const obj = {}
        obj[this.pDataPass.item.codigo] = ''
        obj[this.pDataPass.item.nombre] = ''
        this.$emit('select', obj)
        this.$emit('change', '')
      }
    },
    /**
     * Comprueba si el valor es numerico
     */
    'dSelected.nombre': function (val, oldVal) {
      if ((this.dSelected.nombre === '') || (this.dSelected.nombre === undefined)) {
        this.dSelected.codigo = ''
        this.dErrorMessagesComponente = []
        const obj = { codigo: '', nombre: '' }
        this.$emit('select', obj)
        this.$emit('change', '')
      }
    }
  },
  created() {
    this.dErrorMessagesComponente = this.pDataPass.errorMessages
    if (this.pDataPass.item.codigo) {
      this.dSelected = {
        codigo: this.pDataPass.item.codigo,
        nombre: this.pDataPass.item.nombre
      }
    } else if (this.pDataPass.default.codigo) {
      this.dSelected = {
        codigo: this.pDataPass.default.codigo,
        nombre: this.pDataPass.default.nombre
      }
    }
  },
  methods: {
    fSelectItem(item) {
      this.dSelected = item

      this.dDataTable.isVisible = false
      // Emite el reseteo de la página de la tabla
      this.$refs.TablaInterna.fResetPage()
      // emite el evento hacia el llamador

      this.$emit('select', this.dSelected)
      this.$emit('change', '')
    },
    fCargaEvent(parametros) {
      this.fCargaDatos(parametros.sortBy, parametros.descending, parametros.page, parametros.rowsPerPage, parametros.search, parametros.filters)
    },
    fCloseDialog() {
      this.dDataTable.isVisible = false
      this.$refs.TablaInterna.fResetPage()
    },
    fChangeDisabled(disabledPass) {
      this.dDisabledInput = disabledPass
    },
    /*
     * Selecciona un elemento
     */
    fSeleccionaElemento(event) {
      this.dActivaBusqueda = true
      const descending = this.pDataPass.orderDefault !== 'ASC'
      if ((this.dSelected.codigo !== '') || (this.dSelected.nombre !== '')) {
        if ((this.dSelected.codigo === '') || (this.dSelected.codigo === undefined)) {
          this.dDataTable.initSearch = this.dSelected.nombre
          this.fCargaDatos(this.pDataPass.orderByDefault, descending, 1, this.pDataPass.rowsPerPage, this.dSelected.nombre, [])
        } else {
          this.dDataTable.initSearch = (this.dSelected.codigo && this.dSelected.codigo !== null) ? this.dSelected.codigo.toString() : ''
          this.fCargaDatos(this.pDataPass.orderByDefault, descending, 1, this.pDataPass.rowsPerPage, this.dSelected.codigo, [])
        }
      }
    },
    fActualizarItem(item) {
      this.dSelected = item
    },
    /**
     * Abre el buscador de la tabla
     */
    fAbreBuscador() {
      this.dActivaBusqueda = true
      this.dSelected = { 'codigo': '', 'nombre': '' }
      const descending = this.pDataPass.orderDefault !== 'ASC'
      if (this.dSelected.codigo === null) {
        this.dSelected = { codigo: '', nombre: '' }
      }
      if ((this.dSelected.codigo === '') || (this.dSelected.codigo === undefined)) {
        this.dDataTable.initSearch = this.dSelected.nombre
        this.fCargaDatos(this.pDataPass.orderByDefault, descending, 1, this.pDataPass.rowsPerPage, this.dSelected.nombre, [])
      } else {
        this.dDataTable.initSearch = (this.dSelected.codigo && this.dSelected.codigo !== null) ? this.dSelected.codigo.toString() : ''
        this.fCargaDatos(this.pDataPass.orderByDefault, descending, 1, this.pDataPass.rowsPerPage, this.dSelected.codigo, [])
      }
    },
    fClear() {
      this.dSelected = { 'codigo': '', 'nombre': '' }
      this.$emit('clean')
    },
    fClean() {
      this.dSelected = { 'codigo': '', 'nombre': '' }
    },
    fRecargarValores(object) {
      this.dSelected = object ? {
        codigo: object.codigo,
        nombre: object.nombre
      } : {}
    },
    /*
     * Obtiene una columna
     */
    fGetColumna(sortBy) {
      if (this.pDataPass.headers) {
        if (this.pDataPass.headers.length > 0) {
          for (let i = 0; i < this.pDataPass.headers.length; i++) {
            const header = this.pDataPass.headers[i]
            if (header.value === sortBy) {
              return header.column
            }
          }
        }
      }
      return this.pDataPass.orderByDefault
    },
    fAssignedItems(response) {
      this.dDataTable.items = []
      if (response.data[this.pDataPass.resultName].length > 1) {
        this.dDataTable.items = response.data[this.pDataPass.resultName].map((item) => {
          return {
            codigo: item[this.pDataPass.filters.codigo],
            nombre: item[this.pDataPass.filters.nombre]
          }
        })
        this.dDataTable.totalItems = response.data.numReg
        if (this.dActivaBusqueda) {
          this.dDataTable.isVisible = true
        }
        this.dActivaBusqueda = false
      } else if (response.data[this.pDataPass.resultName].length === 1) {
        this.dDataTable.items = response.data[this.pDataPass.resultName].map((item) => {
          return {
            codigo: item[this.pDataPass.filters.codigo],
            nombre: item[this.pDataPass.filters.nombre]
          }
        })
        this.dSelected = {
          codigo: response.data[this.pDataPass.resultName][0][this.pDataPass.filters.codigo],
          nombre: response.data[this.pDataPass.resultName][0][this.pDataPass.filters.nombre]
        }
        this.$emit('select', this.dSelected)
        this.$emit('change', '')
      } else {
        this.dErrorMessagesComponente = [this.$t('noExisteElemento')]
        this.$refs.nameUserDat.clearableCallback()
        this.$emit('change', this.dErrorMessagesComponente)
      }
      this.dLoadingText = false
      if (this.pDataPass.isVisibleLoad) {
        this.dLoadingCharge = false
      }
    },
    /*
     *  Carga los datos.
     */
    fCargaDatos(sortBy, descending, page, rowsPerPage, search, filters, byCodigo) {
      this.dErrorMessagesComponente = []
      this.$emit('search')
      this.dLoadingText = true
      if (this.pDataPass.isVisibleLoad) {
        this.dLoadingCharge = true
      }

      const orderBy = sortBy === undefined ? this.pDataPass.orderByDefault : this.fGetColumna(sortBy)
      const order = descending ? 'DESC' : 'ASC'
      const numRows = rowsPerPage === undefined ? this.pDataPass.rowsPerPage : rowsPerPage
      const searchVal = search === null ? '' : search
      const offset = this.pDataPass.rowsPerPage * ((page === undefined ? 1 : page) - 1) + 1
      const searchCols = this.pDataPass.filters.codigo + ',' + this.pDataPass.filters.nombre

      const jsonEntrada = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        estado: 'A',
        offset,
        numRows,
        searchCols,
        orderBy,
        order
      }

      if (localStorage.getItem('isOnPremise') === 'yes') {
        jsonEntrada.search = searchVal
      } else {
        const req = this.pDataPass.request
        if (req.cliente) {
          jsonEntrada.cliente = req.cliente
        }
        if (searchVal !== '' && !isNaN(searchVal) && this.pDataPass.orderByDefault === 'sucursal') {
          jsonEntrada.sucursal = searchVal
        } else if (this.pDataPass.urlWS === 'lovArt') {
          jsonEntrada.search = searchVal ? `%${searchVal}%` : '%%%'
        } else {
          const searchLike = searchVal ? `%${searchVal}%` : '%%%'
          jsonEntrada.searchClienteIdentFiscalNombreRazonSocial = searchLike
          jsonEntrada.searchClienteRazonSocialTelefonoEmail = searchLike
        }
        jsonEntrada.codigoProveedor = searchVal || ''
      }

      if (this.dSelected.codigo) {
        jsonEntrada[this.pDataPass.filters.codigo] = searchVal
      }
      if (this.pDataPass.client) {
        jsonEntrada.cliente = this.pDataPass.client
      }
      if (this.pDataPass.request.empresa != null) {
        jsonEntrada.empresa = this.pDataPass.request.empresa
      }
      if (this.pDataPass.sucursal) {
        jsonEntrada.sucursal = this.pDataPass.client
      }
      const req = this.pDataPass.request
      if (req.estado) {
        jsonEntrada.estado = req.estado
      }
      if (req.conCompras) {
        jsonEntrada.conCompras = req.conCompras
      }
      if (req.codigoProveedor) {
        jsonEntrada.codigoProveedor = req.codigoProveedor
      }

      const stopLoading = () => {
        this.dLoadingText = false
        if (this.pDataPass.isVisibleLoad) {
          this.dLoadingCharge = false
        }
      }
      const onReject = (error) => {
        console.log(error)
        const msg = error.response.data.statusText
        this.$emit('alert', msg ? '<b>' + this.pDataPass.resultName + '</b><br> ' + msg : '<b>' + this.$t('vencimientoNotFoundError') + '</b><br> ' + this.$t('vencimientoNotFoundErrorDesc'))
        stopLoading()
      }

      if (!this.pDataPass.request) {
        console.log('No hay request pasado')
        this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + this.$t('errorDefaultDesc'))
        stopLoading()
        return
      }

      const method = this.pDataPass.urlWS === 'lovClte' ? 'lovClte' : this.pDataPass.urlWS
      if (method !== 'lovClte' && (!SrvGeneral[method] || typeof SrvGeneral[method] !== 'function')) {
        this.$emit('alert', `No se ha podido realizar la llamada a ${this.pDataPass.urlWS}`)
      }
      SrvGeneral[method](jsonEntrada)
        .then(response => {
          if (response.data.statusCode === '200') {
            this.fAssignedItems(response)
          }
          else {
            this.$emit('alert', '<b>' + this.pDataPass.resultName + '</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
            stopLoading()
          }
        })
        .catch(onReject)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components_datadec/DatTextFieldCode.vue